import { z } from 'zod';
import { FONT_SIZE_ABSOLUTE_MAX, FONT_SIZE_ABSOLUTE_MIN } from '@/helpers/preview/font-size-cqh.helper';

export const updateEventSettingsSchema = z.object({
  backgroundType: z.enum(['image', 'color']).optional(),
  backgroundColor: z.string().optional(),
  textColor: z.string().optional(),
  backgroundImage: z.instanceof(File).optional(),
  eventLogoImage: z.instanceof(File).optional(),
  /** Staged until Save; ignored by API when a new logo file is also sent. */
  deleteEventLogo: z.boolean().optional(),
  /** Replaces the room behind every remote speaker's camera. */
  remoteSpeakerBackgroundImage: z.instanceof(File).optional(),
  deleteRemoteSpeakerBackground: z.boolean().optional(),
  backgroundOverlay: z.boolean().optional(),
  backgroundOverlayColor: z.string().optional(),
  backgroundOverlayTransparency: z.number().min(0).max(100).optional(),
  /** Absolute cqh font size (standard = 2; UI exposes 0.5×–2× where stored = UI × 2). */
  fontSizeMultiplier: z.number().min(FONT_SIZE_ABSOLUTE_MIN).max(FONT_SIZE_ABSOLUTE_MAX).optional(),
  liveTranslationFontSizeMultiplier: z.number().min(FONT_SIZE_ABSOLUTE_MIN).max(FONT_SIZE_ABSOLUTE_MAX).optional(),
  liveTranslationTextColor: z.string().optional(),
  margins: z
    .object({
      top: z.number().optional(),
      bottom: z.number().optional(),
      left: z.number().optional(),
      right: z.number().optional(),
    })
    .optional(),
});

export type UpdateEventSettingsForm = z.infer<typeof updateEventSettingsSchema>;
